import type { ReactNode } from 'react';
import { cameraDistance } from '@/lib/units.js';

/**
 * Original schematic of the ideal setup — drawn as inline SVG so there is no
 * asset licence question and it scales on every screen.
 */
export function SetupIllustration(): ReactNode {
  return (
    <svg
      viewBox="0 0 320 160"
      className="h-auto w-full"
      role="img"
      aria-label="A person sitting at a desk seen from the side, with a phone on a stand at their side about two metres (six feet) away, at chest height."
    >
      <rect x="0" y="0" width="320" height="160" fill="var(--color-surface)" rx="12" />
      {/* floor */}
      <line x1="16" y1="136" x2="304" y2="136" stroke="var(--color-line)" strokeWidth="2" />
      {/* desk */}
      <rect x="150" y="86" width="96" height="6" rx="3" fill="var(--color-ink-soft)" />
      <rect x="240" y="92" width="5" height="44" fill="var(--color-ink-soft)" />
      {/* laptop */}
      <path d="M196 86 l14 -18 h18 l-6 18 z" fill="var(--color-muted)" />
      {/* chair */}
      <rect x="118" y="100" width="42" height="6" rx="3" fill="var(--color-ink-soft)" />
      <rect x="118" y="62" width="6" height="44" rx="3" fill="var(--color-ink-soft)" />
      <rect x="150" y="106" width="5" height="30" fill="var(--color-ink-soft)" />
      {/* person: side view, upright */}
      <circle cx="158" cy="52" r="11" fill="none" stroke="var(--color-state-good)" strokeWidth="3" />
      <line x1="156" y1="63" x2="150" y2="100" stroke="var(--color-state-good)" strokeWidth="3" />
      <line x1="150" y1="100" x2="186" y2="100" stroke="var(--color-state-good)" strokeWidth="3" />
      <line x1="186" y1="100" x2="190" y2="134" stroke="var(--color-state-good)" strokeWidth="3" />
      <line x1="156" y1="72" x2="192" y2="84" stroke="var(--color-state-good)" strokeWidth="3" />
      {/* phone on stand */}
      <rect x="52" y="58" width="20" height="36" rx="4" fill="var(--color-ink)" />
      <rect x="55" y="62" width="14" height="28" rx="2" fill="#cbd5e1" />
      <path d="M62 94 l-10 24 h20 z" fill="var(--color-ink-soft)" />
      {/* field of view */}
      <path d="M72 76 L150 40 L150 128 Z" fill="var(--color-state-good)" opacity="0.08" />
      {/* distance marker */}
      <line x1="62" y1="146" x2="168" y2="146" stroke="var(--color-muted)" strokeWidth="1" strokeDasharray="4 3" />
      <text x="96" y="156" fontSize="10" fill="var(--color-muted)">
        {cameraDistance()}
      </text>
      <text x="30" y="46" fontSize="10" fill="var(--color-muted)">
        chest height
      </text>
    </svg>
  );
}
